import React from 'react';
import './Fleet.css';

const WA = '919445879508';

const vehicles = [
  {
    name: '4-Seater Car',
    seats: 4, type: 'Swift Dzire / Toyota Etios / Similar',
    img: 'https://images.unsplash.com/photo-1606664515524-ed2f786a0bd6?w=700&q=80',
    features: ['Air Conditioned', 'Music System', 'Comfortable Seats', 'Large Boot Space', 'Phone Charging'],
    best: ['Couples', 'Honeymoon Trips', 'Small Families', 'Solo Travellers'],
    desc: 'Our 4-seater cars are ideal for couples and small families. Compact yet comfortable, they handle the winding mountain roads to Kodaikanal with ease.',
    color: '#e8f5ee',
  },
  {
    name: '7-Seater SUV',
    seats: 7, type: 'Toyota Innova / Maruti Ertiga / Similar',
    img: 'https://images.unsplash.com/photo-1533473359331-0135ef1b58bf?w=700&q=80',
    features: ['Air Conditioned', 'Spacious Cabin', 'Powerful Engine', 'Extra Luggage Space', 'Pushback Seats'],
    best: ['Families', 'Extended Family', 'Small Groups', '2–3 Couples'],
    desc: 'Our most popular choice for families and small groups. The Innova/Ertiga class handles mountain roads excellently while keeping everyone comfortable.',
    color: '#fff8e8',
  },
  {
    name: '12-Seater Van',
    seats: 12, type: 'Force Traveller / Similar',
    img: 'https://images.unsplash.com/photo-1558979158-65a1eaa08691?w=700&q=80',
    features: ['Air Conditioned', 'Row Seating', 'Large Windows', 'Central Aisle', 'Luggage Rack'],
    best: ['Large Families', 'Friend Groups', 'Small College Trips', 'Office Groups'],
    desc: 'Perfect for larger groups who want to stay together without splitting into multiple vehicles. Comfortable, spacious, and great for mountain terrain.',
    color: '#f0f4ff',
  },
  {
    name: '25-Seater Mini Coach',
    seats: 25, type: 'Tempo Traveller / Mini Coach',
    img: 'https://images.unsplash.com/photo-1570125909232-eb263c188f7e?w=700&q=80',
    features: ['Air Conditioned', 'Push-back Seats', 'PA System', 'Large Windows', 'Luggage Compartment'],
    best: ['College Groups', 'Corporate Outings', 'Tour Groups', 'Large Events'],
    desc: 'Our largest vehicle for big group travel. Ideal for college excursions, corporate team outings, and large tour groups exploring Kodaikanal together.',
    color: '#fef0f0',
  },
];

export default function Fleet() {
  return (
    <div className="fleet-page page-enter">
      <div className="inner-hero" style={{ backgroundImage: "url('https://images.unsplash.com/photo-1448375240586-882707db888b?w=1600&q=80')" }}>
        <div className="inner-hero__overlay" />
        <div className="container inner-hero__content">
          <p className="eyebrow">Travel in Comfort</p>
          <h1 className="display-title light">Our Fleet</h1>
          <div className="amber-line" />
          <p>4 vehicle types — for couples, families, and large groups. All AC, well-maintained.</p>
        </div>
      </div>

      <section className="section-pad container">
        <div className="fleet-detail-grid">
          {vehicles.map((v, i) => (
            <div key={v.name} className={`vehicle-detail card ${i % 2 === 1 ? 'reverse' : ''}`}>
              <div className="vehicle-detail__img">
                <img src={v.img} alt={v.name} loading="lazy" />
                <div className="vehicle-detail__badge">
                  <span className="vehicle-detail__seats">👤 {v.seats} Seats</span>
                </div>
              </div>
              <div className="vehicle-detail__info" style={{ background: v.color }}>
                <p className="eyebrow">Available Now</p>
                <h2 className="vehicle-detail__name">{v.name}</h2>
                <p className="vehicle-detail__type">{v.type}</p>
                <div className="amber-line" />
                <p className="vehicle-detail__desc">{v.desc}</p>
                <div className="vehicle-detail__cols">
                  <div>
                    <p className="vehicle-detail__label">Features</p>
                    <ul>
                      {v.features.map(f => <li key={f}><span>✓</span> {f}</li>)}
                    </ul>
                  </div>
                  <div>
                    <p className="vehicle-detail__label">Best For</p>
                    <ul>
                      {v.best.map(b => <li key={b}><span>🏔️</span> {b}</li>)}
                    </ul>
                  </div>
                </div>
                <div className="vehicle-detail__actions">
                  <a href={`https://wa.me/${WA}?text=Hi!%20I'd%20like%20to%20book%20the%20${encodeURIComponent(v.name)}%20for%20Kodaikanal`}
                     target="_blank" rel="noreferrer" className="btn-primary">
                    💬 Book on WhatsApp
                  </a>
                  <a href="tel:+919445879508" className="btn-green">📞 Call Now</a>
                </div>
              </div>
            </div>
          ))}
        </div>
      </section>
    </div>
  );
}
